export const MAKES_MODELS = {
  Ford: ["F-150", "F-250", "F-350", "F-450", "F-550", "Ranger", "Maverick", "F-650", "F-750", "F-800", "LT9000", "Expedition", "Explorer", "Bronco", "Bronco Sport", "Edge", "Escape", "Flex"],
  RAM: ["1500", "2500", "3500", "4500", "5500", "Dakota"],
  Chevrolet: ["Silverado 1500", "Silverado 2500HD", "Silverado 3500HD", "Colorado", "Avalanche", "Kodiak", "Tahoe", "Suburban", "Traverse", "Equinox", "Trailblazer", "Blazer", "Trax"],
  GMC: ["Sierra 1500", "Sierra 2500HD", "Sierra 3500HD", "Canyon", "TopKick 4500", "TopKick 5500", "TopKick 6500", "TopKick 7500", "TopKick 8500", "Yukon", "Yukon XL", "Acadia", "Terrain", "Envoy"],
  Toyota: ["Tundra", "Tacoma", "T100", "Hilux", "Land Cruiser", "4Runner", "Sequoia", "Highlander", "RAV4", "Venza", "Fortuner", "FJ Cruiser"],
  Nissan: ["Titan", "Titan XD", "Frontier", "Navara", "Armada", "Pathfinder", "Murano", "Rogue", "Patrol"],
  Honda: ["Ridgeline", "Pilot", "Passport", "CR-V", "HR-V"],
  Jeep: ["Gladiator", "Grand Cherokee", "Grand Wagoneer", "Wagoneer", "Cherokee", "Compass", "Renegade", "Wrangler"],
  Dodge: ["Dakota", "Durango", "Journey"],
  Isuzu: ["D-Max", "NPR", "NQR", "NRR", "FTR", "FVR", "FXR", "FXZ"],
  International: ["LT Series", "HV Series", "HX Series", "MV Series", "ProStar", "LoneStar", "4300", "4400", "7400", "7600", "8600", "9400", "9900"],
  Kenworth: ["T170", "T270", "T370", "T440", "T470", "T680", "T800", "T880", "W900", "W990", "C500"],
  Peterbilt: ["337", "348", "365", "367", "379", "384", "386", "389", "567", "579", "587"],
  Freightliner: ["Cascadia", "Classic XL", "Columbia", "Coronado", "M2 106", "M2 112", "FL60", "FL70", "FL80", "FL106", "FLD120"],
  Mack: ["Anthem", "Pinnacle", "Granite", "TerraPro", "LR", "MD Series", "CH Series"],
  Volvo: ["VNL 300", "VNL 400", "VNL 760", "VNL 860", "VHD", "VAH", "VNR 300", "VNR 400", "XC90", "XC60", "XC40"],
  "Western Star": ["4700", "4800", "4900", "5700XE", "6900"],
  Hino: ["155", "195", "258", "268", "338", "500 Series", "700 Series"],
  "Mercedes-Benz": ["Actros", "Arocs", "Atego", "Axor", "Antos", "GLS", "GLE", "GLC", "GLA", "GLB", "G-Class"],
  Scania: ["R-Series", "S-Series", "G-Series", "P-Series", "L-Series"],
  MAN: ["TGX", "TGS", "TGM", "TGL"],
  DAF: ["XF", "CF", "LF", "XG"],
  Iveco: ["S-Way", "Stralis", "Daily", "Eurocargo", "Trakker"],
  Kia: ["Telluride", "Sorento", "Sportage"],
  Hyundai: ["Palisade", "Santa Fe", "Tucson"],
  Subaru: ["Forester", "Outback", "Ascent", "Crosstrek"],
  "Land Rover": ["Defender", "Discovery", "Range Rover", "Range Rover Sport", "Velar", "Evoque"],
  BMW: ["X7", "X6", "X5", "X4", "X3", "X2", "X1"],
  Audi: ["Q8", "Q7", "Q5", "Q3"],
  Cadillac: ["Escalade", "Escalade ESV", "XT6", "XT5", "XT4"],
  Lincoln: ["Navigator", "Navigator L", "Aviator", "Corsair", "Nautilus"],
  Infiniti: ["QX80", "QX60", "QX50"],
  Lexus: ["LX", "GX", "RX", "NX"],
};

export const MAKES = Object.keys(MAKES_MODELS);

export const VEHICLE_TYPES = [
  { value: "pickup", label: "Pickup Truck" },
  { value: "truck", label: "Heavy Duty / Commercial Truck" },
  { value: "suv", label: "SUV" },
  { value: "crossover", label: "Crossover" },
];

export const TRUCK_CLASSES = ["Class 1", "Class 2", "Class 3", "Class 4", "Class 5", "Class 6", "Class 7", "Class 8"];

export const CONDITIONS = ["New", "Used", "Certified Pre-Owned"];

export const TRANSMISSIONS = ["Automatic", "Manual", "Semi-Automatic"];

export const FUEL_TYPES = ["Gasoline", "Diesel", "Hybrid", "Electric", "CNG", "LNG"];

export const DRIVETRAINS = ["2WD", "4WD", "AWD", "6x4", "8x4", "6x2"];

export const ENGINE_TYPES = ["V6", "V8", "Inline-4", "Inline-6", "Diesel Inline-6", "Diesel V8", "Hybrid 4-Cylinder", "Hybrid V6", "Electric"];

export const YEARS = Array.from({ length: 2026 - 1990 + 1 }, (_, i) => 2026 - i);

export const typeLabel = (value) =>
  VEHICLE_TYPES.find((t) => t.value === value)?.label || value;
